import script from "./StoreMemberShipRegistration.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreMemberShipRegistration.vue?vue&type=script&setup=true&lang=ts"

import "./StoreMemberShipRegistration.vue?vue&type=style&index=0&id=24014f63&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24014f63"]])

export default __exports__